/** Absolute link to the itemized-bills overview page, on this app's own origin. */
export const getItemizedBillsRedirectLink = () =>
  `${window.location.origin}/#/portal/documents/itemized-bills`;
